import firebase from './firebase';
const db = firebase.database();
export function logIn(email, password) {
    return firebase.auth().setPersistence(firebase.auth.Auth.Persistence.LOCAL) // SESSION)
        .then(function () {
        return firebase.auth().signInWithEmailAndPassword(email, password);
    });
}
export function logOut() {
    return firebase.auth().signOut();
}
// export const onAuthStateChanged = firebase.auth().onAuthStateChanged;
export function onAuthStateChanged(callback) {
    firebase.auth().onAuthStateChanged(callback);
}
export function loadBotList(userId, onBots, onConversationChange, onMessageChange) {
    const bots = {};
    const queries = [];
    // TODO: compare to firebase.firestore.FieldValue.serverTimestamp()
    // this can not be used locally, only in set() and update()
    // const now = firebase.firestore.FieldValue.serverTimestamp();
    // Load the list of bots that the user has access to
    db.ref(`users/${userId}/bots`).once('value').then((doc) => {
        doc.forEach(bot => {
            // console.info('bot:', bot.key, bot.val());
            const val = bot.val();
            const botId = val.botId;
            bots[botId] = {
                id: botId,
                name: val.name
            };
            console.info(`=============botRef: clients/${val.clientId}/bots/${botId}`);
            const botPath = `clients/${val.clientId}/bots/${botId}`;
            const botRef = db.ref(botPath);
            botRef.child('conversations').on('child_added', (convSnapshot) => {
                console.info('conversation snapshot:', convSnapshot.val());
                onConversationChange('added', {
                    id: convSnapshot.key,
                    path: convSnapshot.ref.toString().replace(/https:\/\/[^\/]+\//, ''),
                    botId,
                    // name: data.userName,
                    agentIds: convSnapshot.val().agentIds
                });
            });
            /*botRef.child('messages')
            // .where('ttl', '>=', now)
              .on('child_added', (msgSnapshot: DataSnapshot) => {
                console.info('.........message_added:', msgSnapshot);
                // const data = change.doc.data();
                // data.ttl = data.ttl.seconds
                // data.timestamp = data.timestamp.seconds
                /!*const message = msgSnapshot.val() as RequestFromUser;
                if (!message.requestId) {
                  message.requestId = msgSnapshot.key!;
                }
                message.botId = botId;
                onMessageChange('added', message);*!/
              });*/
            queries.push(botRef.child('conversations'));
            // queries.push(botRef.child('messages'));
        });
        onBots(bots);
    }).catch((err) => {
        console.error('failed to load user bot list:', err.message);
    });
    return () => {
        queries.forEach(query => {
            query.off();
        });
    };
}
export function loadMessages({ conversationId, path }, onLoaded, onNewMessage) {
    console.info('loadMessages:', path);
    const messagesRef = db.ref(path).orderByChild('timestamp'); // .orderByPriority()
    messagesRef.once('value').then((convSnapshot) => {
        const messages = [];
        convSnapshot.forEach((doc) => {
            const message = doc.val();
            console.info('loaded message:', message, doc.getPriority());
            if (!message.requestId) {
                message.requestId = doc.key;
            }
            messages.push(message);
        });
        onLoaded({
            conversationId,
            messages
        });
    }).catch((err) => {
        console.error('failed to load messages from', path, err);
    });
    // TODO: return unsubscriber
    messagesRef.on('child_added', (msgSnapshot) => {
        console.info('message added:', msgSnapshot);
        const message = msgSnapshot.val();
        if (!message.requestId) {
            message.requestId = msgSnapshot.key;
        }
        onNewMessage(message);
    });
}
export function sendResponse(path, response) {
    response.response.timestamp = firebase.database.ServerValue.TIMESTAMP;
    console.info('sending response:', path);
    return db.ref(path).update({
        response: response.response,
        nlpResult: response.nlpResult
    });
}
//# sourceMappingURL=firebase-api.js.map